import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import { Card, Spin, Row, Col } from 'antd';
import { queries } from '../../graphql/graphql';
import AvailableArea from './AvailableArea';
import ContractorInfo from './AdminView/ContractorInfo';
import MetaInfo from './AdminView/MetaInfo';
import PhotoGallery from './AdminView/PhotoGallery';
import PlanDetails from './AdminView/PlanDetails';
import _s from './index.less';
import _svg from './svg.less';

const AdminView = ({ match }) => {
  const { params } = match;
  const { loading: planLoading, data: planData = {}, error: planError } = useQuery(queries.PLAN, {
    variables: { id: params.id },
    fetchPolicy: 'network-only'
  });

  const { plan } = planData;

  const { loading: contractorLoading, data: contractorData = {} } = useQuery(queries.CONTRACTOR, {
    variables: { id: plan && plan.contractorId },
    skip: !plan || !plan.contractorId
  });

  if (planError) return <div>Error loading plan: {planError.message}</div>;
  if (planLoading || !plan) return <Spin size="large" />;

  const { contractor } = contractorData;

  return (
    <div className={_s.container}>
      <Card>
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={16}>
            <PlanDetails plan={plan} />
            <MetaInfo meta={plan.meta} />
          </Col>

          <Col xs={24} lg={8}>
            <Card size="small" title="Contractor Information">
              <ContractorInfo loading={contractorLoading} contractor={contractor} />
            </Card>

            <Card size="small" title="Available Areas" style={{ marginTop: '16px' }}>
              <AvailableArea
                available={plan.available || {}}
                setAvailable={() => {}}
                disabled={true}
              />
            </Card>

            {plan.planSVG && (
              <Card size="small" title="Plan SVG" style={{ marginTop: '16px' }}>
                <div className={_svg.svgView} style={{ width: '100%', overflow: 'hidden' }}>
                  <object
                    type="image/svg+xml"
                    data={`https://3d.homewip.com/svg/${plan.planId}/`}
                    title="plan"
                    aria-label="plan"
                    style={{ width: '100%', height: 'auto', maxWidth: '100%' }}
                  />
                </div>
              </Card>
            )}
          </Col>

          <Col span={24}>
            <PhotoGallery photos={plan.photos} planTitle={plan.title} />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

AdminView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    })
  }).isRequired
};

export default AdminView;
